"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetExtendedContactDetailsAllOfStatisticsLinks {
    static getAttributeTypeMap() {
        return GetExtendedContactDetailsAllOfStatisticsLinks.attributeTypeMap;
    }
}
GetExtendedContactDetailsAllOfStatisticsLinks.discriminator = undefined;
GetExtendedContactDetailsAllOfStatisticsLinks.attributeTypeMap = [
    {
        "name": "count",
        "baseName": "count",
        "type": "number"
    },
    {
        "name": "eventTime",
        "baseName": "eventTime",
        "type": "string"
    },
    {
        "name": "ip",
        "baseName": "ip",
        "type": "string"
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "string"
    }
];
exports.GetExtendedContactDetailsAllOfStatisticsLinks = GetExtendedContactDetailsAllOfStatisticsLinks;
//# sourceMappingURL=getExtendedContactDetailsAllOfStatisticsLinks.js.map